import {Button, Card, Form, Input, Layout, message, Typography} from "antd";
import {Content} from "antd/lib/layout/layout";
import {useInjection} from "inversify-react";
import {EmailTestApi, SendTestEmailDto} from "../../api";
import ApiService from "../../services/apiService";
import styles from "../beerLower/beerListContainer.module.scss";

export default function EmailTestContainer() {
    const apiService = useInjection(ApiService);
    const [form] = Form.useForm<SendTestEmailDto>();

    const onSubmit = async (values: SendTestEmailDto) => {
        try {
            await apiService.getApi(EmailTestApi).apiEmailTestSendPost(values);

            message.success(`Mail testowy został wysłany na adres ${values.email}`);
            form.resetFields();
        } catch (e: any) {
            message.error(e.response?.data?.title || "Nie udało się wysłać maila testowego");
        }
    };

    return <Layout style={{backgroundColor: "white"}}>
        <h1>Test konfiguracji email</h1>
        <Content className={styles.content}>
            <Card style={{maxWidth: 640}}>
                <Typography.Paragraph>
                    Wpisz adres email i wyślij wiadomość testową, żeby sprawdzić konfigurację wysyłki.
                </Typography.Paragraph>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                >
                    <Form.Item
                        label="Adres email"
                        name="email"
                        rules={[
                            {required: true, message: "Podaj adres email"},
                            {type: "email", message: "Podano niepoprawny format adresu email"}
                        ]}
                    >
                        <Input placeholder="np. test@example.com"/>
                    </Form.Item>
                    <Button type="primary" htmlType="submit">
                        Wyślij mail testowy
                    </Button>
                </Form>
            </Card>
        </Content>
    </Layout>;
}
